var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogotypeFair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 40,
    viewBox: "0 0 87 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1958_3548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.38452 18.3016H0V12.8943H4.38452V10.0312C4.38452 3.39688 7.45024 0 14.3205 0C15.591 0 17.2274 0.214905 18.0214 0.478336V5.99653C17.4414 5.78163 16.3298 5.62218 15.3769 5.62218C12.1524 5.62218 11.0476 6.94627 11.0476 10.1837V12.8873H17.7038V18.2946H11.0476V39.3553H4.38452V18.2946V18.3016Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7133 12.8943V39.3691H46.8628C44.3564 39.3691 42.3195 37.3241 42.3195 34.8076C40.7866 37.5113 37.2997 40.0069 32.7011 40.0069C24.878 40.0069 19.3818 33.747 19.3818 26.1629C19.3818 18.5789 24.878 12.2634 32.7011 12.2634C37.2997 12.2634 40.8902 14.6482 42.209 17.4627V12.9012H48.7064L48.7133 12.8943ZM33.9716 34.4887C38.3561 34.4887 42.0571 31.2513 42.0571 26.156C42.0571 21.0607 38.3561 17.7747 33.9716 17.7747C29.2142 17.7747 26.0449 21.539 26.0449 26.156C26.0449 30.773 29.2142 34.4887 33.9716 34.4887Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5395 0.582275C61.8112 0.582275 63.5028 2.32924 63.5028 4.50602C63.5028 6.6828 61.8112 8.42976 59.5395 8.42976C57.2678 8.42976 55.5762 6.73132 55.5762 4.50602C55.5762 2.28072 57.3162 0.582275 59.5395 0.582275Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0366 12.8943C85.3082 12.8943 86.9999 14.6413 86.9999 16.818C86.9999 18.9948 85.3082 20.7418 83.0366 20.7418C80.7649 20.7418 79.0732 19.0433 79.0732 16.818C79.0732 14.5927 80.8132 12.8943 83.0366 12.8943Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8681 12.8943H56.2119V39.3692H62.8681V12.8943Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8153 12.8943C73.2524 12.8943 70.3662 15.792 70.3662 19.3692V39.3692H76.8153V12.8943Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1958_3548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeFair);
export default __webpack_public_path__ + "static/media/logotype_fair.221c0926ff0417727e41facb9e4494c6.svg";
export { ForwardRef as ReactComponent };